/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import * as tslib_1 from "tslib";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
export var API_BASE_URL_IDENTIFYING = new InjectionToken('API_BASE_URL_IDENTIFYING');
var IdentifyingClient = /** @class */ (function () {
    function IdentifyingClient(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * Get cluster groups
     * @return Returns a list of cluster groups
     */
    IdentifyingClient.prototype.getClusterGroups = function () {
        var _this = this;
        var url_ = this.baseUrl + "/clustergroups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClusterGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClusterGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetClusterGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(ClusterGroupDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get clusters
     * @param clusterGroupIds (optional) A comma-separated list of unique identifiers of cluster groups
     * @return Returns a list of clusters
     */
    IdentifyingClient.prototype.getClusters = function (clusterGroupIds) {
        var _this = this;
        var url_ = this.baseUrl + "/clusters?";
        if (clusterGroupIds === null)
            throw new Error("The parameter 'clusterGroupIds' cannot be null.");
        else if (clusterGroupIds !== undefined)
            url_ += "clusterGroupIds=" + encodeURIComponent("" + clusterGroupIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClusters(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClusters(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetClusters = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(ClusterTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get countries
     * @return Returns a list of countries
     */
    IdentifyingClient.prototype.getCountries = function () {
        var _this = this;
        var url_ = this.baseUrl + "/countries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(CountryTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get domains
     * @return Returns a list of domains
     */
    IdentifyingClient.prototype.getDomains = function () {
        var _this = this;
        var url_ = this.baseUrl + "/domains";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDomains(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDomains(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetDomains = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(DomainTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Create a job scan
     * @param body (optional) The job scan to be created
     * @return Success
     */
    IdentifyingClient.prototype.createJobScan = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateJobScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateJobScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processCreateJobScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = JobScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scans for account of current connected client
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the current identified account
     */
    IdentifyingClient.prototype.getJobScans = function (externalRef, shouldHaveExpectations, includeExpectations, teamRoleIds, workValueIds, offset, count, sort, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans?";
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetJobScans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(JobScanDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Delete job scans
     * @param ids (optional) Comma-separated list of ids of the job scans to delete
     * @return Returns status code 204 if successfully deleted
     */
    IdentifyingClient.prototype.deleteJobScans = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteJobScans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteJobScans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processDeleteJobScans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Update a job scan
     * @param body (optional) The job scan to be updated
     * @return Success
     */
    IdentifyingClient.prototype.updateJobScan = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateJobScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateJobScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processUpdateJobScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = JobScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan by id
     * @return Returns the job scan object
     */
    IdentifyingClient.prototype.getJobScan = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetJobScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = JobScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get schools
     * @return Returns a list of schools
     */
    IdentifyingClient.prototype.getSchools = function () {
        var _this = this;
        var url_ = this.baseUrl + "/schools";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSchools(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSchools(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetSchools = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(SchoolTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Create a talent scan
     * @param language (optional) The two-letter iso code for the talent scan's language, eg 'en'
     * @param body (optional) The talent scan to be created
     * @return Success
     */
    IdentifyingClient.prototype.createTalentScan = function (language, body) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans?";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTalentScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTalentScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processCreateTalentScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TalentScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Delete talent scans
     * @param ids (optional) Comma-separated list of id's of the talent scans to delete
     * @return Returns status code 204 if successfully deleted
     */
    IdentifyingClient.prototype.deleteTalentScans = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTalentScans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTalentScans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processDeleteTalentScans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scans for account of current connected client
     * @param externalRef (optional) The unique reference of the talent scan at the account side
     * @param shouldHaveExpectations (optional) Whether talent scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning talent scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of talent scans for the current identified account
     */
    IdentifyingClient.prototype.getTalentScans = function (externalRef, shouldHaveExpectations, includeExpectations, teamRoleIds, workValueIds, offset, count, sort, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans?";
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetTalentScans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(TalentScanDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Update a talent scan
     * @param body (optional) The talent scan to be updated
     * @return Success
     */
    IdentifyingClient.prototype.updateTalentScan = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTalentScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTalentScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processUpdateTalentScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TalentScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan
     * @return Returns the talent scan object in the system
     */
    IdentifyingClient.prototype.getTalentScan = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScan(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScan(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    IdentifyingClient.prototype.processGetTalentScan = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TalentScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return IdentifyingClient;
}());
export { IdentifyingClient };
var ApiError = /** @class */ (function () {
    function ApiError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiError.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    };
    ApiError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiError();
        result.init(data);
        return result;
    };
    ApiError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    };
    return ApiError;
}());
export { ApiError };
var ValidationError = /** @class */ (function () {
    function ValidationError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidationError.prototype.init = function (_data) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
        }
    };
    ValidationError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidationError();
        result.init(data);
        return result;
    };
    ValidationError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        return data;
    };
    return ValidationError;
}());
export { ValidationError };
var ApiErrorResponse = /** @class */ (function () {
    function ApiErrorResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiErrorResponse.prototype.init = function (_data) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
            this.detail = _data["detail"];
        }
    };
    ApiErrorResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiErrorResponse();
        result.init(data);
        return result;
    };
    ApiErrorResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        data["detail"] = this.detail;
        return data;
    };
    return ApiErrorResponse;
}());
export { ApiErrorResponse };
var ClusterGroupDto = /** @class */ (function () {
    function ClusterGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClusterGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ClusterGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClusterGroupDto();
        result.init(data);
        return result;
    };
    ClusterGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return ClusterGroupDto;
}());
export { ClusterGroupDto };
var Translation = /** @class */ (function () {
    function Translation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Translation.prototype.init = function (_data) {
        if (_data) {
            this.en = _data["en"];
            this.nl = _data["nl"];
            this.fr = _data["fr"];
        }
    };
    Translation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Translation();
        result.init(data);
        return result;
    };
    Translation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["nl"] = this.nl;
        data["fr"] = this.fr;
        return data;
    };
    return Translation;
}());
export { Translation };
var ClusterTranslatedDto = /** @class */ (function () {
    function ClusterTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClusterTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    ClusterTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClusterTranslatedDto();
        result.init(data);
        return result;
    };
    ClusterTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return ClusterTranslatedDto;
}());
export { ClusterTranslatedDto };
var CountryTranslatedDto = /** @class */ (function () {
    function CountryTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CountryTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.alpha3IsoCode = _data["alpha3IsoCode"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    CountryTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CountryTranslatedDto();
        result.init(data);
        return result;
    };
    CountryTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["alpha3IsoCode"] = this.alpha3IsoCode;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return CountryTranslatedDto;
}());
export { CountryTranslatedDto };
var DomainTranslatedDto = /** @class */ (function () {
    function DomainTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DomainTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    DomainTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DomainTranslatedDto();
        result.init(data);
        return result;
    };
    DomainTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return DomainTranslatedDto;
}());
export { DomainTranslatedDto };
var CreateJobScanDto = /** @class */ (function () {
    function CreateJobScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateJobScanDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [];
                for (var _i = 0, _a = _data["contactCcEmail"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contactCcEmail.push(item);
                }
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _f = 0, _g = _data["clusterIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.clusterIds.push(item);
                }
            }
        }
    };
    CreateJobScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateJobScanDto();
        result.init(data);
        return result;
    };
    CreateJobScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (var _i = 0, _a = this.contactCcEmail; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contactCcEmail"].push(item);
            }
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _f = 0, _g = this.clusterIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["clusterIds"].push(item);
            }
        }
        return data;
    };
    return CreateJobScanDto;
}());
export { CreateJobScanDto };
var ExpectationDto = /** @class */ (function () {
    function ExpectationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpectationDto.prototype.init = function (_data) {
        if (_data) {
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    };
    ExpectationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpectationDto();
        result.init(data);
        return result;
    };
    ExpectationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data;
    };
    return ExpectationDto;
}());
export { ExpectationDto };
var JobScanDto = /** @class */ (function () {
    function JobScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    JobScanDto.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [];
                for (var _i = 0, _a = _data["expectations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.expectations.push(ExpectationDto.fromJS(item));
                }
            }
            this.id = _data["id"];
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [];
                for (var _b = 0, _c = _data["contactCcEmail"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.contactCcEmail.push(item);
                }
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _d = 0, _e = _data["domainIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.domainIds.push(item);
                }
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _f = 0, _g = _data["schoolIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.schoolIds.push(item);
                }
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _h = 0, _j = _data["clusterIds"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.clusterIds.push(item);
                }
            }
        }
    };
    JobScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new JobScanDto();
        result.init(data);
        return result;
    };
    JobScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (var _i = 0, _a = this.expectations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["expectations"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (var _b = 0, _c = this.contactCcEmail; _b < _c.length; _b++) {
                var item = _c[_b];
                data["contactCcEmail"].push(item);
            }
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _d = 0, _e = this.domainIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["domainIds"].push(item);
            }
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _f = 0, _g = this.schoolIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["schoolIds"].push(item);
            }
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _h = 0, _j = this.clusterIds; _h < _j.length; _h++) {
                var item = _j[_h];
                data["clusterIds"].push(item);
            }
        }
        return data;
    };
    return JobScanDto;
}());
export { JobScanDto };
var UpdateJobScanDto = /** @class */ (function () {
    function UpdateJobScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateJobScanDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [];
                for (var _i = 0, _a = _data["contactCcEmail"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contactCcEmail.push(item);
                }
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _f = 0, _g = _data["clusterIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.clusterIds.push(item);
                }
            }
        }
    };
    UpdateJobScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateJobScanDto();
        result.init(data);
        return result;
    };
    UpdateJobScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (var _i = 0, _a = this.contactCcEmail; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contactCcEmail"].push(item);
            }
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _f = 0, _g = this.clusterIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["clusterIds"].push(item);
            }
        }
        return data;
    };
    return UpdateJobScanDto;
}());
export { UpdateJobScanDto };
var SchoolTranslatedDto = /** @class */ (function () {
    function SchoolTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SchoolTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    SchoolTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SchoolTranslatedDto();
        result.init(data);
        return result;
    };
    SchoolTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return SchoolTranslatedDto;
}());
export { SchoolTranslatedDto };
var CreateTalentScanDto = /** @class */ (function () {
    function CreateTalentScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTalentScanDto.prototype.init = function (_data) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _i = 0, _a = _data["clusterIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clusterIds.push(item);
                }
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
        }
    };
    CreateTalentScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTalentScanDto();
        result.init(data);
        return result;
    };
    CreateTalentScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _i = 0, _a = this.clusterIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clusterIds"].push(item);
            }
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        return data;
    };
    return CreateTalentScanDto;
}());
export { CreateTalentScanDto };
var TalentScanDto = /** @class */ (function () {
    function TalentScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TalentScanDto.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [];
                for (var _i = 0, _a = _data["expectations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.expectations.push(ExpectationDto.fromJS(item));
                }
            }
            this.id = _data["id"];
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _b = 0, _c = _data["clusterIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.clusterIds.push(item);
                }
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _d = 0, _e = _data["domainIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.domainIds.push(item);
                }
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _f = 0, _g = _data["schoolIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.schoolIds.push(item);
                }
            }
        }
    };
    TalentScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TalentScanDto();
        result.init(data);
        return result;
    };
    TalentScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (var _i = 0, _a = this.expectations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["expectations"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _b = 0, _c = this.clusterIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["clusterIds"].push(item);
            }
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _d = 0, _e = this.domainIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["domainIds"].push(item);
            }
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _f = 0, _g = this.schoolIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["schoolIds"].push(item);
            }
        }
        return data;
    };
    return TalentScanDto;
}());
export { TalentScanDto };
var UpdateTalentScanDto = /** @class */ (function () {
    function UpdateTalentScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateTalentScanDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _i = 0, _a = _data["clusterIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clusterIds.push(item);
                }
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
        }
    };
    UpdateTalentScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTalentScanDto();
        result.init(data);
        return result;
    };
    UpdateTalentScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _i = 0, _a = this.clusterIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clusterIds"].push(item);
            }
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        return data;
    };
    return UpdateTalentScanDto;
}());
export { UpdateTalentScanDto };
var SwaggerException = /** @class */ (function (_super) {
    tslib_1.__extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
